import { render } from "./edu.vue?vue&type=template&id=069f9db4&scoped=true"
import script from "./edu.vue?vue&type=script&lang=js"
export * from "./edu.vue?vue&type=script&lang=js"

import "./edu.vue?vue&type=style&index=0&id=069f9db4&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069f9db4"]])

export default __exports__